import type { ID, ResourceResponse, ThunkReturnType } from "types";
import type { PayloadAction, WritableDraft } from "infrastructure/store";
import { ApiState } from "infrastructure/api";
import { updateTableSliceEntity, deleteTableSliceEntity } from "infrastructure/store/helpers";
import type { Application, ApplicationsResponse, OnboardingState } from "./types";

export const applicationsRequestLoading = (state: WritableDraft<OnboardingState>) => {
    state.tableLoadingState = ApiState.Pending;
};

export const applicationsRequestFulfilled = (
    state: WritableDraft<OnboardingState>,
    { payload }: PayloadAction<ThunkReturnType<ApplicationsResponse>>
) => {
    state.tableLoadingState = ApiState.Succeeded;
    state.tableSlice = payload!.data;
};

export const applicationsRequestRejected = (state: WritableDraft<OnboardingState>) => {
    state.tableLoadingState = ApiState.Failed;
};

export const updateApplicationRequestFulfilled = (
    state: WritableDraft<OnboardingState>,
    { payload }: PayloadAction<ThunkReturnType<ResourceResponse<Application>>>
) => {
    state.tableLoadingState = ApiState.Succeeded;
    state.tableSlice!.data = updateTableSliceEntity(state, payload!.data);
};

export const deleteApplicationRequestFulfilled = (
    state: WritableDraft<OnboardingState>,
    { payload }: PayloadAction<ThunkReturnType<ResourceResponse<ID>>>
) => {
    state.tableLoadingState = ApiState.Succeeded;
    deleteTableSliceEntity(state, payload!.data);
};
